import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { shouldNotForwardProp } from '@ori/presentation-utils';
import { LinearProgress as LinearProgressComponent, LoadingButton, styled } from '@ori-ui/mui';
export var Root = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
});
export var InfoText = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3)
  };
});
export var LinearProgress = styled(LinearProgressComponent, {
  shouldForwardProp: shouldNotForwardProp(['isButtonVisible'])
})(function (_ref2) {
  var isButtonVisible = _ref2.isButtonVisible,
    theme = _ref2.theme;
  return {
    height: '8px',
    marginBottom: isButtonVisible ? theme.spacing(6) : 0,
    width: '100%'
  };
});
export var PaginationLoadMoreButton = styled(LoadingButton)(function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    width: '100%'
  }, theme.breakpoints.up('sm'), {
    width: 'unset'
  });
});
//# sourceMappingURL=styles.js.map